import { MakeCall } from 'ha/services/apiV2/createMakeCall';

export type AllPayoutMethodRoutingData = {
  listingIdsByMethodId: {
    [payoutMethodId: string]: number[];
  };
};

const getAllPayoutMethodRouting = (makeCall: MakeCall) => (userId: number) =>
  makeCall<AllPayoutMethodRoutingData>(
    'GET',
    `/v1/user/${userId}/payout-routing/link`,
  );

export default getAllPayoutMethodRouting;
